import { Box, Typography, Chip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { VideoItem } from '../VideoCarousel/VideoCarouselModal';

interface HeroVideoSearchResultItemProps {
  video: VideoItem;
  onSelect: (video: VideoItem) => void;
}

export function HeroVideoSearchResultItem({ video, onSelect }: HeroVideoSearchResultItemProps) {
  return (
    <Box
      onClick={() => onSelect(video)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        p: 1.5,
        cursor: 'pointer',
        '&:hover': { bgcolor: 'action.hover' },
        borderBottom: '1px solid',
        borderColor: 'divider',
        '&:last-child': { borderBottom: 0 },
      }}
    >
      <Box
        component="img"
        src={video.thumbnail}
        alt={video.title}
        sx={{
          width: 80,
          height: 45,
          objectFit: 'cover',
          borderRadius: 1,
          flexShrink: 0,
        }}
      />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" noWrap sx={{ fontWeight: 500 }}>
          {video.title}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mt: 0.5,
          }}
        >
          <Typography variant="caption" color="text.secondary">
            {video.duration}
          </Typography>
          {video.channelName && (
            <Chip label={video.channelName} size="small" sx={{ height: 18, fontSize: 10 }} />
          )}
        </Box>
      </Box>
      <AddIcon color="primary" />
    </Box>
  );
}
